import React, { useEffect } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";

import FormWarning from "./FormWarning"

const EasySelect = (props) => {
  const { propName, classes } = props;
  const setPropMounted = props.connectForm.setPropMounted;

  useEffect(() => {
    setPropMounted(propName, true);
    return () => {
      setPropMounted(propName, false);
    };
  }, [setPropMounted, propName]);

  const shouldDisplayLabel = () => {
    return (
      props.connectForm.getLabel(propName) === "Type" || 
      props.connectForm.getLabel(propName) === "Where did you hear about MCSnet?" ||
      props.connectForm.getLabel(propName) === "Quarter" ||
      props.connectForm.getLabel(propName) === "Section" ||
      props.connectForm.getLabel(propName) === "Township" ||
      props.connectForm.getLabel(propName) === "Range" ||
      props.connectForm.getLabel(propName) === "Meridian" ? true : false
      )
  };

  return (
    <FormControl
      fullWidth
      className={classes.selectFormControl}
      error = {props.connectForm.getState(propName) === "Error"}
    >
      {shouldDisplayLabel? null : 
        <InputLabel htmlFor={propName} className={classes.selectLabel}>
          {props.connectForm.getLabel(propName) + " "}
          {props.connectForm.isRequired(propName) ? (
            <span style={{ color: "rgb(10 64 101)" }}>*</span>
            ) : (
              ""
              )}
        </InputLabel>
      }
      <Select
        MenuProps={{
          className: classes.selectMenu,
        }}
        classes={{
          select: props.connectForm.getState(propName) === "Error" && props.connectForm.isRequired(propName)? 
          classes.newErrorClass : classes.select 
        }}
        value={props.connectForm.getValue(propName)}
        onChange={(event) =>
          props.connectForm.change(event.target.value, propName)
        }
        inputProps={{
          name: propName,
          id: propName,
        }}
      >
        {props.connectForm.getDropdownOptions(propName).map((element, key) => {
          if (Array.isArray(element)) {
            return (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected
                }}
                value={element[0]}
              >
                {element[1]}
              </MenuItem>
            );
          } else {
            return (
              <MenuItem
                key={key}
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelect,
                }}
                value={element}
              >
                {element}
              </MenuItem>
            );
          }
        })}
      </Select>
      <FormWarning
      isValid = { props.propName }
      isError = { props.connectForm.getState(propName) }
      errorMessage = { props.connectForm.getErrorMessage(propName) }
    />
    </FormControl>
  );
};

export default withStyles(styles)(EasySelect);

//
//
